import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetParentsOnboardingBatchesByIdParams {
  batchId: string;
  page?: number;
  limit?: number;
}

export interface GetParentsOnboardingBatchesByIdResponse {
  id: string;
  successCount: number;
  failedCount: number;
  parents: Array<OnboardingParent>;
  pagination: Pagination;
}

export interface Pagination {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface OnboardingParent {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  status: string;
}

export const getParentsOnboardingBatchesById = async ({
  batchId,
  page = 1,
  limit = 10,
}: GetParentsOnboardingBatchesByIdParams) => {
  const response = await baseAPI.get<GetParentsOnboardingBatchesByIdResponse>(
    `parents/onboarding/batches/${batchId}/parents`,
    {
      params: {
        page,
        limit,
      },
    },
  );
  return response.data;
};

export const useGetParentsOnboardingBatchesById = ({
  batchId,
  page,
  limit,
}: GetParentsOnboardingBatchesByIdParams) => {
  return useQuery({
    queryKey: [KEYS.PARENTS_ONBOARDING_BATCHES_BY_ID, batchId, page, limit],
    queryFn: () => getParentsOnboardingBatchesById({ batchId, page, limit }),
    placeholderData: keepPreviousData,
  });
};
